import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-BudgetShape",
  "use": "svg-icon-BudgetShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-BudgetShape\"><path d=\"M21 7h-2V3c0-.2 0-.4-.1-.6-.2-.5-.5-.9-1-1.2-.5-.2-1-.3-1.5-.1L1.7 5.6c-.4.2-.7.6-.7 1V21c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM2.5 7l14.4-4.4h.4c.1.1.2.2.2.3v4L2.5 7zm19 14c0 .3-.2.5-.5.5H3c-.3 0-.5-.2-.5-.5V8.5H21c.3 0 .5.2.5.5v12z\" /><circle class=\"st0\" cx=\"16\" cy=\"15\" r=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol